/*
 * @Description: 全局样式
 * @Date: 2022-03-09 16:42:16
 * @LastEditTime: 2022-03-29 16:36:04
 */
import Vue from 'vue';
import App from './App.vue';

import '@/assets/style/global.css';
import '@/assets/style/theme/index.css';
import '@/assets/style/rtc.scss';
import { isMobile } from '@/utils/utils';

// Vant 组件库
import {
  Button,
  Field,
  Popup,
  Tab,
  Tabs,
  Empty,
  Icon,
  Cell,
  CellGroup,
  Toast,
  Dialog,
  ActionSheet,
  ImagePreview,
  Loading,
  Progress,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Picker,
  Swipe,
  SwipeItem,
  Search,
  Rate,
  Switch
} from 'vant';
import 'vant/lib/index.css';

Vue.use(Button);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ActionSheet);
Vue.use(ImagePreview);
Vue.use(Loading);
Vue.use(Progress);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Picker);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Search);
Vue.use(Rate);
Vue.use(Switch);

import 'lib-flexible';


import router from './router';
import store from './store';


Vue.prototype.$isMobile = isMobile;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
